import {createI18n} from 'vue-i18n'
import {localeFr} from '~/locales/fr'
import {localeEn} from '~/locales/en'

export default defineNuxtPlugin({
    name: 'i18n',
    setup(nuxtApp) {
        const i18n = createI18n({
            legacy: false,
            globalInjection: true,
            messages: {
                fr: localeFr,
                en: localeEn,
            },
            locale: 'en',
            fallbackLocale: 'en',
            fallbackWarn: false,
            missingWarn: false,
        })

        nuxtApp.vueApp.use(i18n)

        // 🔑 on expose explicitement l’instance globale
        nuxtApp.provide('i18n', i18n.global)
    }
})
